import React from 'react';
import { BookOpenIcon, CalculatorIcon, GiftIcon, ShieldCheckIcon, SmartphoneIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { BONUS_VALUE, bonuses } from '../data/content';
const ICONS = {
  book: BookOpenIcon,
  calculator: CalculatorIcon,
  gift: GiftIcon,
  phone: SmartphoneIcon,
  shield: ShieldCheckIcon
};

/* Colores de cada bono, igual que en la portada del pack */
const BONUS_COLORS = ['bg-pink-600', 'bg-amber-700', 'bg-purple-600', 'bg-green-700', 'bg-blue-600'];
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-white text-brand-choco" data-id="element-27" data-mp="1eje2g7malizh">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-28" data-mp="1eim8t2c99vbu">
        <h2 id="bonos" className="font-display text-lg font-black uppercase leading-tight sm:text-2xl" data-id="element-29" data-mp="19lm00jo0ueh1">
          <span className="rounded border-2 border-brand-gold bg-brand-choco px-2 text-white" data-id="element-30" data-mp="1nhzj1x87enxm">
            5 Bonos incluidos
          </span>
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-[0.8rem] leading-snug text-brand-choco/80" data-id="element-31" data-mp="3prdf4b72r3xm">
          Y además recibís 5 recursos prácticos —{' '}
          <span className="font-semibold text-brand-pink" data-id="element-32" data-mp="3ttqiisycmpr8">GRATIS</span> con tu
          compra.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-33" data-mp="7kpa0lc0ygry">
          {bonuses.map((bono, i) => {
          const Icon = ICONS[bono.icon];
          return <Reveal key={bono.title} as="li" delay={i * 0.03} className="flex h-full flex-col overflow-hidden rounded-lg border-2 border-brand-blush bg-white text-left" data-id="element-34" data-mp="cjaa8kra10ge" data-mpi={i}>
                <span className={`flex items-center gap-1.5 px-2.5 py-1 font-display text-[0.62rem] font-black uppercase tracking-[0.1em] text-white ${BONUS_COLORS[i]}`} data-id="element-35" data-mp="qax8gq4s4j1t">
                  <Icon size={12} aria-hidden="true" data-id="element-36" data-mp="108ux3eqjwhuy" />
                  Bono {i + 1} — Gratis
                </span>
                <div className="flex flex-1 flex-col p-2.5" data-id="element-37" data-mp="amabq5qteiei">
                  <h3 className="font-display text-[0.8rem] font-extrabold uppercase leading-tight" data-id="element-38" data-mp="5m5v8fpwpnoa">
                    {bono.title}
                  </h3>
                  <p className="mt-0.5 text-[0.74rem] leading-snug text-brand-choco/80" data-id="element-39" data-mp="kcldpmqxuhir">
                    {bono.desc}
                  </p>
                  <p className="mt-auto pt-1 font-display text-sm font-black uppercase tracking-wide text-brand-choco/60 line-through decoration-brand-pink decoration-2" data-id="element-40" data-mp="tbqg545mev07">
                    {bono.value}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>

        <div className="mt-3 inline-block rounded-lg border-2 border-dashed border-brand-gold bg-brand-cream px-3 py-2 font-display text-[0.78rem] font-black uppercase leading-tight sm:text-sm" data-id="element-41" data-mp="yb2zvg173lyk">
          <p data-id="element-42" data-mp="302g19v3yfbpv">💰 Valor total de los 5 bonos: {BONUS_VALUE}</p>
          <p className="mt-0.5 text-brand-pink" data-id="element-43" data-mp="3040vfjmcwsn7">
            🔥 Hoy los 5 están incluidos gratis.
          </p>
        </div>
      </div>
    </section>;
}